import React from 'react';
import { connect } from 'react-redux';
import { Loader } from 'Components/Loader';
import './Overlay.css';

export const Overlay = ({ pageLayout }) => {
  return pageLayout.showOverlay ? (
    <div className="overlay show">
      {pageLayout.overlayMessage && <h3 className="overlayMessage">{pageLayout.overlayMessage}</h3>}
      {pageLayout.showOverlayLoader && (
        <div className="overlayLoader">
          <Loader />
        </div>
      )}
    </div>
  ) : null;
};

export const OverlayHOC = connect(({ pageLayout }) => ({
  pageLayout,
}))(Overlay);
